const awsmobile =  {
    "aws_cognito_region": process.env.REACT_APP_REGION,
    "aws_user_pools_id": process.env.REACT_APP_POOL_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_CLIENT_ID,
    "aws_cognito_identity_pool_id": "eu-west-1:6c5edd74-2d6b-4f57-8338-7f70eb48b2fc",
  };
  
  export default awsmobile;